const indexItems = [
  { letter: 'A', items: ['暗夜追光者', '暗战风云', '爱在星光下'] },
  { letter: 'B', items: ['白夜破晓', '冰河追凶', '步步惊情'] },
  { letter: 'C', items: ['苍穹之刃', '长安十二时辰', '沉默的证人'] },
  { letter: 'D', items: ['大江奔流', '谍影重重', '冬日暖阳'] },
  { letter: 'F', items: ['浮生若梦记', '飞驰人生', '风暴之眼'] },
  { letter: 'J', items: ['极境生存', '绝命追踪', '锦绣未央'] },
  { letter: 'L', items: ['烈火如歌', '流浪苍穹', '猎罪图鉴'] },
  { letter: 'S', items: ['时空缉凶', '三体·剧集版', '深海迷航'] },
  { letter: 'W', items: ['武动乾坤', '无名之辈', '完美世界'] },
];

export default function Index() {
  return (
    <section id="index" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">剧集索引</h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">按字母快速查找蓝莓影院收录的精彩影视内容</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {indexItems.map((group) => (
            <div
              key={group.letter}
              className="bg-background-50 border border-background-200/70 rounded-xl p-5 hover:border-primary-200 transition-all duration-300"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-9 h-9 rounded-lg bg-primary-100 flex items-center justify-center">
                  <span className="font-heading text-lg text-primary-600">{group.letter}</span>
                </div>
                <span className="text-xs text-foreground-400">{group.items.length} 部作品</span>
              </div>
              <div className="space-y-2">
                {group.items.map((name) => (
                  <div
                    key={name}
                    className="flex items-center gap-2 text-sm text-foreground-600 hover:text-primary-600 transition-colors duration-200 cursor-pointer"
                  >
                    <i className="ri-movie-line text-xs text-foreground-300"></i>
                    <span>{name}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}